import { render, staticRenderFns } from "./Chapters.vue?vue&type=template&id=317797dc&scoped=true&"
import script from "./Chapters.vue?vue&type=script&lang=js&"
export * from "./Chapters.vue?vue&type=script&lang=js&"
import style0 from "./Chapters.vue?vue&type=style&index=0&id=317797dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317797dc",
  null
  
)

export default component.exports